import useScreenWidth from"./useScreenWidth";var useTabletScreen=function(){return useScreenWidth(760)};export default useTabletScreen;